import { ContactUsSchema } from '@/app/(public)/contact-us/components/contactUsSchema';
import { ApiService } from './api.service';

export class EmailService {
  static async sendContactEmail(data: ContactUsSchema) {
    try {
      const response = await ApiService.post('/email/contact', data, {
        requireAuth: false,
      });

      if (response.status === 200) {
        return;
      } else {
        throw new Error('Error al enviar el mensaje');
      }
    } catch {
      throw new Error('Error al enviar el mensaje');
    }
  }
}
